export default __webpack_public_path__ + "static/media/pic.81d9027e.jpg";